module.exports = __webpack_public_path__ + "img/7.440b0377.svg";